<div nz-row *transloco="let t; prefix: 'academy.usersOverviewPage'">
  <aad-title [title]="t('title')" />

  <div nz-col nzSpan="24">
    <aml-datatable
      [columns]="tableColumns()"
      [dataSource]="tableData()"
      [pageIndex]="pageIndex()"
      [hasMore]="hasMore()"
      [isLoading]="isTableLoading()"
      [totalCount]="partialVsTotalCount()"
      (queryParamsChange)="handleQueryParamsChange($event)"
      [showNoResultsErrorMessage]="showNoResultsErrorMessage()"
      [noResultsErrorMessages]="noResultsErrorMessages()"
      [showFilteredDownloadOption]="false"
      (actualTableConfiguration)="saveTableConfiguration($event)"
      (exportClicked)="exportAsXlsxFile($event)"
    />
    <aad-scroll-to-top />
  </div>
</div>
